











import { ModInterface } from "@/types";
import Vue from "vue";
import ModlistEntry from "./ModlistEntry.vue";

export default Vue.extend({
  name: "modlist",
  components: {
    ModlistEntry,
  },
  props: {
    mods: {
      type: Array as () => ModInterface[],
      required: true,
    },
    mutable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    lastMod(): ModInterface {
      return this.mods[this.mods.length - 1];
    },
  },
});
